var _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrinksMenus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6818 5.93182V4.09091C12.6818 3.60267 12.4879 3.13443 12.1426 2.78919C11.7974 2.44395 11.3291 2.25 10.8409 2.25H4.09091C3.60267 2.25 3.13443 2.44395 2.78919 2.78919C2.44395 3.13443 2.25 3.60267 2.25 4.09091V10.8409C2.25 11.3291 2.44395 11.7974 2.78919 12.1426C3.13443 12.4879 3.60267 12.6818 4.09091 12.6818H5.93182M12.6818 5.93182H13.9091C14.3973 5.93182 14.8656 6.12577 15.2108 6.47101C15.556 6.81625 15.75 7.28449 15.75 7.77273V13.9091C15.75 14.3973 15.556 14.8656 15.2108 15.2108C14.8656 15.556 14.3973 15.75 13.9091 15.75H7.77273C7.28449 15.75 6.81625 15.556 6.47101 15.2108C6.12577 14.8656 5.93182 14.3973 5.93182 13.9091V12.6818M12.6818 5.93182H7.77273C7.28449 5.93182 6.81625 6.12577 6.47101 6.47101C6.12577 6.81625 5.93182 7.28449 5.93182 7.77273V12.6818",
    stroke: "current",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.65625,
    y1: 9.34375,
    x2: 13.5625,
    y2: 9.34375,
    stroke: "current",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 11.875,
    x2: 12.7188,
    y2: 11.875,
    stroke: "current",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinksMenus);
export default __webpack_public_path__ + "static/media/drinks-menus.e9dfe5dae3ce8f5f633825ad7c1d532c.svg";
export { ForwardRef as ReactComponent };